
import { defineComponent } from 'vue'
import { useContextQuery } from '../../../composables'
import { SearchBox } from '../../shared'
import ExplainSearchBoxBase from '../explain-search-box-base.component.vue'

export default defineComponent({
  name: 'ExplainQueryAnalysisSearchBox',
  components: {
    SearchBox,
    ExplainSearchBoxBase,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      required: true,
    },
    inputQuery: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { query, setQuery, clearQuery } = useContextQuery()

    return {
      baseClass: 'epb-explain-query-analysis-search-box',
      clearQuery,
      setQuery,
      query,
    }
  },
})
